export const ROLE_USER = 'user';
export const ROLE_ADMIN = 'admin';
export const ORG_NAME_MAX_LENGTH = 60;
export const ORG_ADDRESS_MAX_LENGTH = 120;
export const CITY_MAX_LENGTH = 120;
export const STATE_MAX_LENGTH = 120;
export const EMAIL_MAX_LENGTH = 255;
export const ZIP_CODE_MAX_LENGTH = 10;
export const REDIRECT_DURATION = 11000; // in milliseconds
export const ASC = 'asc';
export const DESC = 'desc';
export const AUTO_APPROVED = 'AUTO APPROVED';
export const MANUAL_APPROVED = 'MANUAL APPROVED';
export const APPROVED = 'APPROVED';
export const PENDING = 'PENDING';
export const REJECTED = 'REJECTED';
export const APP_VERSION = '0.9.0';
export const FILE_SIZE_300KB = 307200;
